import { Component, EventEmitter, Injectable, Input, NgModule, Output, Pipe } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/platform-browser';

const _c0 = function (a0, a1) { return { background: a0, color: a1 }; };
const _c1 = ["*"];
const _c2 = function (a0) { return { color: a0 }; };
function SnackbarComponent_ngx_snack_1_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵlistener("click", function SnackbarComponent_ngx_snack_1_div_3_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const snackbar_r1 = ɵngcc0.ɵɵnextContext().$implicit; return snackbar_r1.action.onClick(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const snackbar_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(2, _c2, snackbar_r1.action.color || ctx_r2.accent));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", snackbar_r1.action.text, " ");
} }
function SnackbarComponent_ngx_snack_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ngx-snack", 2);
    ɵngcc0.ɵɵelement(1, "div", 3);
    ɵngcc0.ɵɵpipe(2, "safeHtml");
    ɵngcc0.ɵɵtemplate(3, SnackbarComponent_ngx_snack_1_div_3_Template, 2, 4, "div", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const snackbar_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("background", snackbar_r1.background || ctx_r0.background)("customClass", snackbar_r1.customClass || ctx_r0.customClass)("color", snackbar_r1.color || ctx_r0.color || ctx_r0.calcTextColor(snackbar_r1.background || ctx_r0.background));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHtml", ɵngcc0.ɵɵpipeBind1(2, 5, snackbar_r1.msg), ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", snackbar_r1.action.text);
} }
class SnackbarService {
    constructor() {
        this.snackService = new Subject();
    }
    /**
     * @return {?}
     */
    get() {
        return this.snackService.asObservable();
    }
    /**
     * @param {?} data
     * @return {?}
     */
    add(data) {
        this.snackService.next({
            action: 'add',
            data: data
        });
    }
    /**
     * @param {?} id
     * @return {?}
     */
    remove(id) {
        this.snackService.next({ action: 'remove', id: id });
    }
    /**
     * @return {?}
     */
    clear() {
        this.snackService.next({ action: 'clear' });
    }
}
SnackbarService.ɵfac = function SnackbarService_Factory(t) { return new (t || SnackbarService)(); };
SnackbarService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: SnackbarService, factory: SnackbarService.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SnackbarService, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
class SnackComponent {
}
SnackComponent.ɵfac = function SnackComponent_Factory(t) { return new (t || SnackComponent)(); };
SnackComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SnackComponent, selectors: [["ngx-snack"]], inputs: { background: "background", color: "color", customClass: "customClass" }, ngContentSelectors: _c1, decls: 2, vars: 5, consts: [[1, "snack", 3, "ngStyle", "ngClass"]], template: function SnackComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction2(2, _c0, ctx.background, ctx.color))("ngClass", ctx.customClass);
    } }, directives: [ɵngcc1.NgStyle, ɵngcc1.NgClass], encapsulation: 2 });
SnackComponent.propDecorators = {
    background: [{ type: Input }],
    color: [{ type: Input }],
    customClass: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SnackComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-snack',
                template: `
      <div class="snack" [ngStyle]="{background: background, color: color}" [ngClass]="customClass">
          <ng-content></ng-content>
      </div>
  `
            }]
    }], null, { background: [{
            type: Input
        }], color: [{
            type: Input
        }], customClass: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
class SnackbarComponent {
    /**
     * @param {?} snackbarService
     */
    constructor(snackbarService) {
        this.snackbarService = snackbarService;
        this.onAdd = new EventEmitter();
        this.onRemove = new EventEmitter();
        this.onClear = new EventEmitter();
        this.snacks = [];
        this.snackbarService.get()
            .subscribe(snack => {
            if (snack.action === 'add') {
                this.add(snack.data);
            }
            else if (snack.action === 'remove') {
                this.remove(snack.id);
            }
            else if (snack.action === 'clear') {
                this.clear();
            }
        });
    }
    /**
     * @param {?} snack
     * @return {?}
     */
    add(snack) {
        /** @type {?} */
        let timeout;
        /** @type {?} */
        const id = this.uuid();
        if (this.max && this.max > 0 && this.snacks.length === this.max) {
            this.remove(this.snacks[0].id);
        }
        if (snack.timeout || this.timeout) {
            timeout = setTimeout(() => {
                this.remove(id);
            }, snack.timeout || this.timeout);
        }
        /** @type {?} */
        const data = Object.assign({ id: id, timeoutObj: timeout }, snack);
        if (snack.action) {
            /** @type {?} */
            const that = this;
            /** @type {?} */
            const fcn = snack.action.onClick || new Function();
            snack.action.onClick = () => {
                fcn(data);
                that.remove(id);
            };
        }
        if (snack.onAdd) {
            snack.onAdd(data);
        }
        if (this.onAdd) {
            this.onAdd.emit(data);
        }
        this.snacks.push(data);
    }
    /**
     * @param {?} id
     * @return {?}
     */
    remove(id) {
        /** @type {?} */
        const snack = this.snacks.find(obj => obj.id === id);
        if (snack) {
            if (snack.onRemove) {
                snack.onRemove(snack);
            }
            if (this.onRemove) {
                this.onRemove.emit(snack);
            }
            if (snack.timeoutObj) {
                clearTimeout(snack.timeoutObj);
            }
        }
        this.snacks = this.snacks.filter(obj => obj.id !== id);
    }
    /**
     * @return {?}
     */
    clear() {
        // this.snacks.forEach(snack => {
        //   this.remove(snack.id);
        // });
        this.snacks = [];
        if (this.onClear) {
            this.onClear.emit(true);
        }
    }
    /**
     * @return {?}
     */
    uuid() {
        // tslint:disable:no-bitwise
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            /** @type {?} */
            const r = Math.random() * 16 | 0;
            /** @type {?} */
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
        // tslint:enable:no-bitwise
    }
    /**
     * @param {?} background
     * @return {?}
     */
    calcTextColor(background) {
        if (!background) {
            return null;
        }
        /**
         * @param {?} hex
         * @return {?}
         */
        function hexToRgb(hex) {
            /** @type {?} */
            const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
            hex = hex.replace(shorthandRegex, (m, r, g, b) => {
                return r + r + g + g + b + b;
            });
            /** @type {?} */
            const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        }
        /** @type {?} */
        const rgb = hexToRgb(background);
        if (!rgb) {
            return null;
        }
        /** @type {?} */
        const color = [rgb.r / 255, rgb.g / 255, rgb.b / 255];
        for (let i = 0; i < color.length; ++i) {
            if (color[i] <= 0.03928) {
                color[i] = color[i] / 12.92;
            }
            else {
                color[i] = Math.pow((color[i] + 0.055) / 1.055, 2.4);
            }
        }
        /** @type {?} */
        const l = 0.2126 * color[0] + 0.7152 * color[1] + 0.0722 * color[2];
        if (l > 0.179) {
            return '#000';
        }
        else {
            return '#fff';
        }
    }
}
SnackbarComponent.ɵfac = function SnackbarComponent_Factory(t) { return new (t || SnackbarComponent)(ɵngcc0.ɵɵdirectiveInject(SnackbarService)); };
SnackbarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SnackbarComponent, selectors: [["ngx-snackbar"]], inputs: { position: "position", max: "max", background: "background", accent: "accent", color: "color", customClass: "customClass", timeout: "timeout" }, outputs: { onAdd: "onAdd", onRemove: "onRemove", onClear: "onClear" }, decls: 2, vars: 2, consts: [[1, "snackbars", 3, "ngClass"], [3, "background", "customClass", "color", 4, "ngFor", "ngForOf"], [3, "background", "customClass", "color"], [1, "snack-text", 3, "innerHtml"], ["class", "snack-action", 3, "ngStyle", "click", 4, "ngIf"], [1, "snack-action", 3, "ngStyle", "click"]], template: function SnackbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, SnackbarComponent_ngx_snack_1_Template, 4, 7, "ngx-snack", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.position || "bottom-right");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.snacks);
    } }, directives: function () { return [ɵngcc1.NgClass, ɵngcc1.NgForOf, SnackComponent, ɵngcc1.NgIf, ɵngcc1.NgStyle]; }, pipes: function () { return [SafeHtmlPipe]; }, encapsulation: 2 });
/** @nocollapse */
SnackbarComponent.ctorParameters = () => [
    { type: SnackbarService }
];
SnackbarComponent.propDecorators = {
    position: [{ type: Input }],
    max: [{ type: Input }],
    background: [{ type: Input }],
    accent: [{ type: Input }],
    color: [{ type: Input }],
    customClass: [{ type: Input }],
    timeout: [{ type: Input }],
    onAdd: [{ type: Output }],
    onRemove: [{ type: Output }],
    onClear: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SnackbarComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-snackbar',
                template: `
      <div class="snackbars" [ngClass]="position || 'bottom-right'">
          <ngx-snack *ngFor="let snackbar of snacks" [background]="snackbar.background || background"
                        [customClass]="snackbar.customClass || customClass"
                        [color]="snackbar.color || color || calcTextColor(snackbar.background || background)">
              <div class="snack-text" [innerHtml]="snackbar.msg | safeHtml">

              </div>
              <div *ngIf="snackbar.action.text" class="snack-action" (click)="snackbar.action.onClick()"
                   [ngStyle]="{color: snackbar.action.color || accent}">
                  {{snackbar.action.text}}
              </div>
          </ngx-snack>
      </div>
  `
            }]
    }], function () { return [{ type: SnackbarService }]; }, { onAdd: [{
            type: Output
        }], onRemove: [{
            type: Output
        }], onClear: [{
            type: Output
        }], position: [{
            type: Input
        }], max: [{
            type: Input
        }], background: [{
            type: Input
        }], accent: [{
            type: Input
        }], color: [{
            type: Input
        }], customClass: [{
            type: Input
        }], timeout: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
class SafeHtmlPipe {
    /**
     * @param {?} sanitized
     */
    constructor(sanitized) {
        this.sanitized = sanitized;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    transform(value) {
        return this.sanitized.bypassSecurityTrustHtml(value);
    }
}
SafeHtmlPipe.ɵfac = function SafeHtmlPipe_Factory(t) { return new (t || SafeHtmlPipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.DomSanitizer)); };
SafeHtmlPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "safeHtml", type: SafeHtmlPipe, pure: true });
/** @nocollapse */
SafeHtmlPipe.ctorParameters = () => [
    { type: DomSanitizer }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SafeHtmlPipe, [{
        type: Pipe,
        args: [{ name: 'safeHtml' }]
    }], function () { return [{ type: ɵngcc2.DomSanitizer }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
class SnackbarModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: SnackbarModule,
            providers: [SnackbarService]
        };
    }
}
SnackbarModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SnackbarModule });
SnackbarModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SnackbarModule_Factory(t) { return new (t || SnackbarModule)(); }, providers: [SnackbarService], imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SnackbarModule, { declarations: function () { return [SnackbarComponent,
        SnackComponent,
        SafeHtmlPipe]; }, imports: function () { return [CommonModule]; }, exports: function () { return [SnackbarComponent,
        SnackComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SnackbarModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [SnackbarComponent, SnackComponent, SafeHtmlPipe],
                exports: [SnackbarComponent, SnackComponent],
                providers: [SnackbarService]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */

export { SnackbarModule, SnackbarService, SafeHtmlPipe as ɵc, SnackComponent as ɵb, SnackbarComponent as ɵa };

//# sourceMappingURL=ngx-snackbar.js.map